import { CheckboxSelector } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'
import moment from 'moment'
import FilterBadge from '../../../common/FilterBadge'

const ClassYearFilter = (props) => {
  const { translate } = useTranslation()
  const { classFilters, setClassFilters } = props
  const currentYear = moment().format('YYYY')
  const selectorData = [0, 1, 2, 3, 4, 5].map((item) => ({
    name: parseInt(currentYear) + item,
    id: parseInt(currentYear) + item
  }))
  return (
    <CheckboxSelector
      setDataFilters={setClassFilters}
      direction='bottom'
      dataFilters={classFilters}
      typeFilter='services'
      data={selectorData}
      strings={{
        viewAll: translate('filters.plans.viewAll'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search')
      }}
    >
      <FilterBadge
        title={translate('filters.users.classYear')}
        options={selectorData}
        selectedIds={classFilters}
        onClearFilters={() => setClassFilters([])}
      />
    </CheckboxSelector>
  )
}
export default ClassYearFilter
